'use client';

import React from 'react';

// ─── MONOLYTH: A NEW NATURE SECTION ─────────────────────────────────────────
// Extracted from Behance gallery: https://www.behance.net/gallery/112291665/Monolyth-(VR)
// Order: Title → Cover Image → Image Grid → Video → Follow-up image → Vision text

const NEW_NATURE_COVER = 'https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/9be7e0112291665.61835c71dff19.jpg';

const NEW_NATURE_GRID_IMAGES = [
  'https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/9e2b90112291665.61838bbaeed22.png',
  'https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/b7adb8112291665.61838bbaee518.jpg',
];

const NEW_NATURE_FOLLOWUP = 'https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/409fc6112291665.6018769e04b9f.jpg';

const VISION_TEXT = `Vision

I seek to remedy the structural violence of environmental racism by platforming the underserved communities it affects most through an interactive game-like experience that presents my research alongside cultural products from local creatives and small minority owned businesses. The platform I will build is an open world virtual cultural center, a series of digital venues that creatively reclaim the industrial corridors my research focuses on by presenting data driven streetmap Glyphs as surreal environments to be explored, and learned from.

The viewer, now an urbexer (Urban Explorer) much like myself when visiting these locations, is tasked with exploring these landscapes in search of artifacts. Virtual urban archaeology, the retrieval of each artifact presents the viewer with a bit of information/research regarding the community/culture it represents. These artifacts are made by individuals from the communities represented in the street map glyphs embedded in each virtual environment. They vary widely, from scans of handmade jewelry, pottery/sculptures to murals, poem inscribed tablets and virtual performances. I will maintain this project as an ongoing virtual platform by updating the game over time to feature more creatives and small businesses from a growing list of communities affected by industry. As I continue my research the open world of the game will grow and serve as a living archive.

The surreal environments of this open world are presented as once home to vibrant cultures whose structural remnants are embedded in each landscape. The experience takes place after a series of erosion events that embody a progression of industrial pollution, based on the research I've done of real world locations driving the erosion of industry adjacent communities of color.

This platform, Monolyth, presents my research with a virtual cultural center/museum of work from local creatives and catalog of minority owned small business and creatives from underserved communities as a virtual marketplace. I envision a way to reinvest in our communities by increasing our awareness of them and counteracting the forms of structural violence we've grown accustomed to.`;

export default function MonolythNewNatureSection() {
  return (
    <section id="new-nature" style={{ backgroundColor: '#fff', paddingBottom: 0 }}>
      {/* Section Title */}
      <div style={{ padding: '20px 7.1%', marginBottom: 20 }}>
        <div style={{ textAlign: 'center' }}>
          <span style={{
            color: '#ffa200',
            fontFamily: 'helvetica, arial, sans-serif',
            fontSize: 35,
            fontWeight: 700,
            lineHeight: '1.1em'
          }}>Monolyth: A New Nature</span>
        </div>
      </div>
      {/* Cover Image */}
      <div style={{ marginBottom: 20 }}>
        <img
          src={NEW_NATURE_COVER}
          alt="Monolyth: A New Nature — cover image"
          style={{ width: '100%', display: 'block' }}
        />
      </div>
      {/* Image Grid — 2 images side by side */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0, marginBottom: 20 }}>
        {NEW_NATURE_GRID_IMAGES?.map((src, i) => (
          <div key={i} style={{ overflow: 'hidden' }}>
            <img
              src={src}
              alt={`Monolyth: A New Nature — image ${i + 1}`}
              style={{ width: '100%', display: 'block' }}
            />
          </div>
        ))}
      </div>
      {/* Embedded YouTube Video */}
      <div style={{ marginBottom: 4 }}>
        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
          <iframe
            src="https://www.youtube.com/embed/K_OaK7je6Kg"
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }}
            allowFullScreen
            title="Monolyth VR — Concept Walkthrough"
          />
        </div>
      </div>
      {/* Caption for video */}
      <div style={{ padding: '0 7.1%', marginBottom: 20, maxWidth: 'calc(800px + 14.2%)', margin: '0 auto 20px' }}>
        <div style={{
          color: '#696969',
          fontFamily: 'helvetica, arial, sans-serif',
          fontSize: 20,
          fontWeight: 400,
          lineHeight: '1.4em',
          textAlign: 'center',
          fontStyle: 'italic'
        }}>
          A short clip of a partially built interative landscape within the game and some of the process behind it, concept panoramas for future levels towards the end.
        </div>
      </div>
      {/* Follow-up Image */}
      <div style={{ marginBottom: 20 }}>
        <img
          src={NEW_NATURE_FOLLOWUP}
          alt="Monolyth: A New Nature — follow-up image"
          style={{ width: '100%', display: 'block' }}
        />
      </div>
      {/* Vision Text */}
      <div style={{ padding: '0 7.1%', marginBottom: 20, maxWidth: 'calc(800px + 14.2%)', margin: '0 auto 20px' }}>
        <div style={{
          color: '#696969',
          fontFamily: 'helvetica, arial, sans-serif',
          fontSize: 20,
          fontWeight: 400,
          lineHeight: '1.4em'
        }}>
          <p style={{ marginBottom: '1em', fontWeight: 700, textAlign: 'center' }}>Vision</p>
          <p style={{ marginBottom: '1em' }}>I seek to remedy the structural violence of environmental racism by platforming the underserved communities it affects most through an interactive game-like experience that presents my research alongside cultural products from local creatives and small minority owned businesses. The platform I will build is an open world virtual cultural center, a series of digital venues that creatively reclaim the industrial corridors my research focuses on by presenting data driven streetmap Glyphs as surreal environments to be explored, and learned from.</p>
          <p style={{ marginBottom: '1em' }}>The viewer, now an urbexer (Urban Explorer) much like myself when visiting these locations, is tasked with exploring these landscapes in search of artifacts. Virtual urban archaeology, the retrieval of each artifact presents the viewer with a bit of information/research regarding the community/culture it represents. These artifacts are made by individuals from the communities represented in the street map glyphs embedded in each virtual environment. They vary widely, from scans of handmade jewelry, pottery/sculptures to murals, poem inscribed tablets and virtual performances. I will maintain this project as an ongoing virtual platform by updating the game over time to feature more creatives and small businesses from a growing list of communities affected by industry. As I continue my research the open world of the game will grow and serve as a living archive.</p>
          <p style={{ marginBottom: '1em' }}>The surreal environments of this open world are presented as once home to vibrant cultures whose structural remnants are embedded in each landscape. The experience takes place after a series of erosion events that embody a progression of industrial pollution, based on the research I&apos;ve done of real world locations driving the erosion of industry adjacent communities of color.</p>
          <p>This platform, Monolyth, presents my research with a virtual cultural center/museum of work from local creatives and catalog of minority owned small business and creatives from underserved communities as a virtual marketplace. I envision a way to reinvest in our communities by increasing our awareness of them and counteracting the forms of structural violence we&apos;ve grown accustomed to.</p>
        </div>
      </div>
    </section>
  );
}
